const teethWhitening = {
  hero: {
    title: "Professionelle Zahnaufhellung (Bleaching)",
    description:
      "Verwandeln Sie Ihr Lächeln mit unseren fortschrittlichen Zahnaufhellungsverfahren. Unsere professionellen Behandlungen können Ihre Zähne in nur einer Sitzung um mehrere Nuancen aufhellen und jahrelange Verfärbungen entfernen.",
    ctas: {
      primary: "Beratungstermin vereinbaren",
      secondary: "Mehr erfahren",
    },
    imageAlt: "Zahnaufhellungsbehandlung",
    callout: {
      title: "Schnelle Behandlungen",
      body: "Die meisten Behandlungen dauern nur 60-90 Minuten",
    },
  },
  benefits: {
    heading: "VORTEILE DER ZAHNAUFHELLUNG",
    intro:
      "Erleben Sie die vielen Vorteile unserer professionellen Zahnaufhellungsdienste",
    items: [
      {
        title: "Gesteigertes Selbstvertrauen",
        description:
          "Ein strahlenderes Lächeln kann Ihr Selbstwertgefühl erheblich steigern und Sie in sozialen und beruflichen Situationen selbstbewusster machen.",
      },
      {
        title: "Dramatische Ergebnisse",
        description:
          "Unsere professionellen Aufhellungsbehandlungen können Ihre Zähne in nur einer Sitzung um mehrere Nuancen aufhellen und liefern sofortige Ergebnisse.",
      },
      {
        title: "Schnelle Behandlung",
        description:
          "Im Gegensatz zu Hausmitteln, die Wochen brauchen, um Ergebnisse zu zeigen, dauern unsere Aufhellungsverfahren in der Praxis typischerweise nur 60-90 Minuten.",
      },
      {
        title: "Maßgeschneiderte Lösungen",
        description:
          "Wir passen unsere Aufhellungsbehandlungen an Ihre individuellen Bedürfnisse und Ihre Empfindlichkeit an, um optimalen Komfort und Ergebnisse zu erzielen.",
      },
      {
        title: "Sicher & Professionell",
        description:
          "Unsere Behandlungen werden von geschultem zahnmedizinischem Fachpersonal unter Verwendung hochwertiger, klinisch geprüfter Aufhellungsmittel durchgeführt.",
      },
      {
        title: "Jugendliches Aussehen",
        description:
          "Ein strahlendes, weißes Lächeln kann Sie um Jahre jünger wirken lassen und hilft Ihnen, jünger und vitaler auszusehen und sich auch so zu fühlen.",
      },
    ],
  },
  process: {
    heading: "DER AUFHELLUNGSPROZESS",
    intro:
      "Unser Zahnaufhellungsprozess ist so konzipiert, dass er sicher, effektiv und komfortabel ist und hervorragende Ergebnisse mit minimaler Empfindlichkeit bietet.",
    steps: [
      {
        title: "Erstberatung",
        description:
          "Wir führen eine gründliche Untersuchung Ihrer Zähne durch und besprechen Ihre Aufhellungsziele, um einen persönlichen Behandlungsplan zu erstellen.",
      },
      {
        title: "Vorbereitung der Zähne",
        description:
          "Ihre Zähne werden professionell gereinigt, um oberflächliche Verfärbungen und Plaque vor dem Aufhellungsverfahren zu entfernen.",
      },
      {
        title: "Auftragen des Aufhellers",
        description:
          "Ein professionelles Aufhellungsgel wird sorgfältig mit maßgefertigten Schienen auf Ihre Zähne aufgetragen, um maximale Wirksamkeit zu erzielen.",
      },
      {
        title: "Lichtaktivierung",
        description:
          "Bei einigen Behandlungen wird ein spezielles Licht verwendet, um den Aufhellungsprozess durch Aktivierung der Inhaltsstoffe im Gel zu beschleunigen.",
      },
      {
        title: "Endergebnisse",
        description:
          "Nach dem Eingriff sehen Sie sofortige Ergebnisse mit Zähnen, die deutlich weißer und strahlender sind.",
      },
      {
        title: "Nachsorgeanweisungen",
        description:
          "Wir geben Ihnen Anleitungen zur Erhaltung Ihres neuen Lächelns, einschließlich Ernährungsempfehlungen und Pflegeprodukten für zu Hause.",
      },
    ],
  },
  faq: {
    heading: "HÄUFIG GESTELLTE FRAGEN",
    intro:
      "Erhalten Sie Antworten auf häufige Fragen zu unseren Zahnaufhellungsbehandlungen",
    items: [
      {
        question: "Wie lange hält eine professionelle Zahnaufhellung?",
        answer:
          "Die Ergebnisse einer professionellen Zahnaufhellung können zwischen 6 Monaten und 2 Jahren halten, abhängig von Ihren Lebensgewohnheiten wie Rauchen, Kaffeekonsum und Mundhygiene. Regelmäßige Auffrischungen können helfen, Ihr strahlendes Lächeln länger zu erhalten.",
      },
      {
        question: "Ist Zahnaufhellung sicher?",
        answer:
          "Ja, wenn sie von zahnmedizinischem Fachpersonal durchgeführt wird, gilt die Zahnaufhellung als sicher. Wir verwenden klinisch getestete Produkte und beurteilen Ihre Mundgesundheit sorgfältig, bevor wir eine Aufhellungsbehandlung empfehlen, um sicherzustellen, dass sie für Sie geeignet ist.",
      },
      {
        question: "Verursacht Zahnaufhellung Empfindlichkeit?",
        answer:
          "Einige Patienten können nach Aufhellungsbehandlungen eine vorübergehende Empfindlichkeit erfahren. Wir treffen jedoch Vorkehrungen, um dies zu minimieren, indem wir vor und nach der Behandlung desensibilisierende Mittel verwenden und die Konzentration des Aufhellungsgels an Ihre spezifischen Bedürfnisse anpassen.",
      },
      {
        question: "Wie weiß werden meine Zähne?",
        answer:
          "Die Ergebnisse variieren von Person zu Person, aber die meisten Patienten sehen eine Verbesserung um 2-8 Nuancen. Das Endergebnis hängt von Ihrer natürlichen Zahnfarbe, der Ursache der Verfärbung und davon ab, wie Ihre Zähne auf die Aufhellungsmittel reagieren.",
      },
      {
        question:
          "Was ist der Unterschied zwischen professioneller Aufhellung und frei verkäuflichen Produkten?",
        answer:
          "Professionelle Aufhellung verwendet höher konzentrierte Aufhellungsmittel, die nicht frei verkäuflich sind, was zu schnelleren und dramatischeren Ergebnissen führt. Zudem werden professionelle Behandlungen auf Ihre spezifischen Bedürfnisse zugeschnitten und von Zahnexperten überwacht, um Sicherheit und Wirksamkeit zu gewährleisten.",
      },
      {
        question: "Wie pflege ich meine aufgehellten Zähne?",
        answer:
          "Um Ihre Ergebnisse zu erhalten, empfehlen wir eine gute Mundhygiene, die Einschränkung des Konsums von verfärbenden Lebensmitteln und Getränken (Kaffee, Rotwein, Tee), den Verzicht auf Tabakprodukte, die Verwendung eines Strohhalms beim Trinken dunkler Flüssigkeiten und die Vereinbarung regelmäßiger Auffrischungsbehandlungen bei Bedarf.",
      },
    ],
  },
};

export default teethWhitening;

